<div id="app" class="app" [dir]="(settings.rtl) ? 'rtl' : 'ltr'" [ngClass]="settings.theme" [class.fixed-header]="settings.fixedHeader" [class.fixed-sidenav]="settings.fixedSidenav"
				[class.fixed-footer]="settings.fixedFooter" [class.horizontal-menu]="isHorizontalMenu" [class.compact]="settings.menuType == 'compact'" [class.mini]="settings.menuType == 'mini'">

	<router-outlet></router-outlet>
</div>